import { IS_DEVELOPMENT } from '@shared/config/env';

export const BuildInformation = () => {
  if (!IS_DEVELOPMENT || !process.env.VITE_AZDO_BUILD_ID || !process.env.VITE_AZDO_BUILD_NUMBER) {
    return null;
  }

  return (
    <div>
      <a
        target='_blank'
        rel='noopener noreferrer'
        className='text-xs text-gray-500'
        href={`https://dev.azure.com/estimationworld/Estimation%20Tool/_build/results?buildId=${process.env.VITE_AZDO_BUILD_ID}`}
      >
        Build version: {process.env.VITE_AZDO_BUILD_NUMBER ?? 1}
      </a>
    </div>
  );
};
